import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.079 6.618L3.427 16.27l-.53 4.773 4.773-.53 9.651-9.652-4.242-4.243zm0-1.414l5.657 5.657L8.253 21.344a.5.5 0 0 1-.298.143l-5.941.66a.2.2 0 0 1-.221-.177c-.001-.01.219-2.004.66-5.985a.5.5 0 0 1 .143-.298L13.08 5.204zm7.07 2.829l1.415-1.415-4.243-4.242-1.414 1.414 4.243 4.243zm-3.535-6.364a1 1 0 0 1 1.415 0L22.27 5.91a1 1 0 0 1 0 1.415l-2.121 2.12-5.657-5.656 2.121-2.121z"
});

var SvgPencil = function SvgPencil(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgPencil;